ACC.feedbackForm = {
  feedbackError: function() {
    $(document).on('blur', '.ph-feedbackForm #ph-feedbackContent', function() {
      var $errorSpan = $(this).find('span:first-child');

      if ($errorSpan.length > 0) {
        $errorSpan.removeClass('form_field_error ph-form_field_error');
      }
    });
  },

  feedbackReset: function() {
    $(document).on('click', '.ph-feedbackForm .ph-feedbackForm__reset', function() {
      location.replace(window.location.href);
    });
  }
};

$(document).ready(function() {
  if ($('.ph-page-contactus').length > 0) {
    ACC.feedbackForm.feedbackError();
    ACC.feedbackForm.feedbackReset();
  }
});
